import { jsx as _jsx } from "react/jsx-runtime";
import { useOverlayContext } from 'seagull';
import { MapTaxRatesModal } from './MapTaxRatesModal';
export const useOpenMapTaxRatesModal = (integration)=>{
    const { showModal } = useOverlayContext();
    return async function openMapTaxRatesModal() {
        await showModal({
            biName: 'map_tax_rates_modal',
            closeOnClickOutside: false,
            closeOnEscapeKey: false,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(MapTaxRatesModal, {
                    integration: integration,
                    dismissModal: dismissModal
                });
            }
        });
    };
};
